"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var StepLabel_1 = __importDefault(require("@mui/material/StepLabel"));
var StepLabel = (0, styled_1.default)(StepLabel_1.default)(function () { return ({
    '&& .MuiStepLabel-alternativeLabel': {
        fontSize: 12,
        marginTop: 4,
        '& .Mui-active': {
            fontWeight: 800,
        },
    },
}); });
exports.default = StepLabel;
//# sourceMappingURL=styles.js.map